import { configureStore } from "@reduxjs/toolkit";
import {
  // FLUSH,
  // REHYDRATE,
  // PAUSE,
  // PERSIST,
  // PURGE,
  // REGISTER,
  persistStore,
  persistReducer,
} from "redux-persist";
import rootReducer from "./rootReducer";
import storage from "redux-persist/lib/storage";
import { endPoint } from "../axios";
import { REAUTH_SOCKET } from "../constants/auth";
import { getUserByContact } from "../services/user";
import { updateOperationsAllCount } from "./slices/sidebareBadges/api";
import { UPDATE_CCAVENUE_TXNS_STATUS } from "../constants/paymentGateWay";
import createSocketIoMiddleware from "redux-socket.io";
import io from "socket.io-client";
import { updateChatData } from "./slices/customerChat/customerChatSlice";
import { updateCCAvenueTxnsStutus } from "./slices/PaymentGateWay/paymentGateWaySlice";
import { getCustomerOrderQuickData } from "./slices/customerBooking/api";
import { setCustomerDocketLocation } from "./slices/liveLocation/liveLocationSlice";
import { acceptIntracityBooking } from "./slices/customerBooking/customerBookingSlice";


const persistConfig = {
  key: "root",
  storage,
  blacklist: [],
  whitelist: ["customerLoginReducer","notification"], // Ensure this is the correct spelling
};

export const socket = io(endPoint, {
  transports: ["websocket", "polling"],
});

// const production = process.env.NODE_ENV == "production";
const role=sessionStorage.getItem("role");
const token =role=="customer"?localStorage.getItem("kabra:customertoken"): sessionStorage.getItem("kabra:token");
if (token) {
  const id = setInterval(() => {
    // console.log("refresh :",token)
    socket.emit("refresh", token);
  }, 5000);
  // socket.on("connect", () => {
  //   socket.emit("action", {
  //     type: REGISTER_SOCKET,
  //     data: { token: token},
  //   });
  // });
  socket.on("logout", () => {
    clearInterval(id);
    window.location.reload();
  });
  socket.on("reconnect", () => {
    socket.emit("action", {
      type: REAUTH_SOCKET,
      data: { token: token },
    });
    if ((store.getState() as any)?.user?.opBranch?._id) {
      const { _id, branchName } = (store.getState() as any)?.user?.opBranch;
      socket.emit("branchLogin", { opBranch: { _id, branchName } });
    }
  });
}
socket.on("setFilteredBranches", async (data: any) => {
  let user =
    store && store.getState() && (store.getState() as any)?.user && (store.getState() as any)?.user;
  // let company =
  //   store &&
  //   store.getState() &&
  //   (store.getState() as any)?.user &&
  //   (store.getState() as any)?.user?.company &&
  //   (store.getState() as any)?.user?.company?._id;
  let isAuthenticated =
    store &&
    store.getState() &&
    (store.getState() as any)?.user &&
    (store.getState() as any)?.user?.socketLockAcquired;

  if (isAuthenticated) {
    try {
      // store.dispatch({
      //   type: "SET_FILTERED_BRANCHES",
      //   payload: {
      //     data: await filterBookBranches({ company } as any),
      //     query: company,
      //   },
      // });
      // store.dispatch({
      //   type: "SET_BRANCHES",
      //   payload: await getAllBranchesByCompany(company as any),
      // });
      if (
        user &&
        user.branches &&
        user.branches.length > 0 &&
        user.branches.find((x: any) => x._id === data.updatedId)
      ) {
        let response = await getUserByContact(user.contact as any);

        store.dispatch({
          type: "SET_USER_BRANCHES",
          payload: response.branches,
        });
      }
      if (user && user.opBranch && user.opBranch._id === data.updatedId) {
        const { user } = store.getState() as any;
        const payload = {
          user: user?.uid,
          sub: "B",
          entity: data.updatedId,
          company: user?.company?._id,
        };
        socket.emit("branchLogin", payload);
        store.dispatch({
          type: "SEL_OP_BRANCH",
          payload: { value: data.updatedId },
          isSocketAction: true,
        });

        store.dispatch(updateOperationsAllCount() as any);
      }
    } catch (err: any) { }
  }
});

socket.on("setUpdatedBranch", async (data: any) => {
  let user =
    store && store.getState() && (store.getState() as any).user && (store.getState() as any).user;

  try {
    if (
      user &&
      user.branches &&
      user.branches.length > 0 &&
      user.branches.find((x: any) => x._id === data.updatedId)
    ) {
      let response = await getUserByContact(user.contact as any);

      await store.dispatch({
        type: "SET_USER_BRANCHES",
        payload: response.branches,
      });
    }

    if (user && user.opBranch && user.opBranch._id === data.updatedId) {
      const { user } = store.getState() as any;
      const payload = {
        user: user?.uid,
        sub: "B",
        entity: data.updatedId,
        company: user?.company._id,
      };
      socket.emit("branchLogin", payload);
      store.dispatch({
        type: "SEL_OP_BRANCH",
        payload: { value: data.updatedId },
        isSocketAction: true,
      });

      store.dispatch(updateOperationsAllCount() as any);
    }
  } catch (err: any) {
    console.log(err);
  }
});

socket.on("setAssignedBranches", async () => {
  let user =
    store && store.getState() && (store.getState() as any).user && (store.getState() as any).user;

  try {
    let response = await getUserByContact(user?.contact as any);

    await store.dispatch({
      type: "SET_USER_BRANCHES",
      payload: response.branches,
    });
  } catch (err: any) {
    console.log(err);
  }
});

socket.on("setAssignedFleets", async () => {
  let user =
    store && store.getState() && (store.getState() as any).user && (store.getState() as any).user;

  try {
    let response = await getUserByContact(user?.contact as any);

    await store.dispatch({
      type: "SET_USER_FLEETS",
      payload: response.fleets,
    });
  } catch (err: any) {
    console.log(err);
  }
});

socket.on("newCustomerBookingNotification", (data: any) => {
  store.dispatch(getCustomerOrderQuickData(data) as any);
});

socket.on("receiveLiveDocketTracking", (data: any) => {
  store.dispatch(setCustomerDocketLocation(data) as any);
});

socket.on("chatMessageUpdated", (data: any) => {
  store.dispatch(updateChatData(data));
});
socket.on("action", (data: any) => {
  if(data.type=="ACCEPT_INTRACITY_BOOKING"){
    console.log("ACCEPT_INTRACITY_BOOKING : ",data)
    store.dispatch(acceptIntracityBooking(data.payload));
  }
});
socket.on(UPDATE_CCAVENUE_TXNS_STATUS, (data: any) => {
  store.dispatch(updateCCAvenueTxnsStutus(data.payload));
});
const socketIOMiddleware: any = createSocketIoMiddleware(socket, "server/");

const persistedReducer = persistReducer(persistConfig, rootReducer as any);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      // serializableCheck: {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      // },
      serializableCheck: false,
      immutableCheck: false, // Disable ImmutableStateInvariantMiddleware
    }).concat(socketIOMiddleware),
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof rootReducer>;

export const persistor = persistStore(store);
